import React from 'react';
import CardSection from '../../common/CardSection';

import User from '../../../models/User';
import FormTextbox, { FormTextBoxDataType } from 'src/components/controls/forms/redesign/FormTextbox';
import { FormErrors } from 'src/util/FormErrors';
import { connect } from 'react-redux';
import actions from 'src/actions';
import { replace } from 'connected-react-router';
import Button from 'src/components/controls/forms/redesign/FormButton';
import UserRole from 'src/models/UserRole';
import Form from 'src/components/controls/forms/Form';
import FormSelect from 'src/components/controls/forms/redesign/FormFilterSelect';
import { SelectItem } from 'src/models/common/SelectItem';
import { IRootState } from 'src/reducers';
import { AnyObject } from 'final-form';
import selectors from 'src/selectors';
import Office from 'src/models/Office';
import PagedResultSet from 'src/models/common/PagedResultSet';
import { UserTypes } from 'src/models/UserType';
import { RouteComponentProps } from 'react-router-dom';
import FormTextBox from 'src/components/controls/forms/redesign/FormTextbox';

interface IAdminCreateUserPageStateProps {
    userRoles: Array<UserRole>;
    offices: Array<Office>;
    users: PagedResultSet<User>;
    allUsers: Array<User>;
    selectedUser: User;
    duplicateUser: boolean;
    errorMessage: string;
}

interface IAdminCreateUserPageDispatchProps {
    navigate: (path: string) => void;
    createUser: (user: User) => void;
    editUser: (user: User) => void;
    getRoles: () => void;
    getFieldOffices: () => void;
    getUsers: (resetPage: boolean) => void;
    getUserById: (id: number) => void;
    initUsers: () => void;
}

type IAdminCreateUserPageProps = RouteComponentProps<{ userId?: string }> & IAdminCreateUserPageDispatchProps & IAdminCreateUserPageStateProps;

class AdminCreateUserPage extends React.Component<IAdminCreateUserPageProps> {
    private userId?: number;
    private buttonText?: string;
    private cardTitle?: string;

    public componentDidMount() {
        this.userId = parseInt(this.props.match.params.userId, 10);
        this.props.getRoles();
        this.props.getFieldOffices();
        this.props.getUsers(true);
        if (this.userId && this.userId > 0) {
            this.props.getUserById(this.userId);
            this.buttonText = 'Save';
            this.cardTitle = 'Edit User';
        } else {
            this.buttonText = 'Create User';
            this.cardTitle = 'Create User';
        }
    }

    public componentWillUnmount() {
        this.props.initUsers();
    }

    validate = (user: User) => {
        const errors: FormErrors<User> = {};
        errors.role = {};
        errors.office = {};
        errors.manager = {};

        if (user.username === undefined) {
            errors.username = 'Email address required';
        }

        if (user.firstName === undefined) {
            errors.firstName = 'First name is required';
        }

        if (user.lastName === undefined) {
            errors.lastName = 'Last name is required';
        }

        if (user.role === undefined) {
            errors.role.id = 'Role is required';
        }

        if (user.office === undefined) {
            errors.office.id = 'Office is required';
        }

        if (user.manager === undefined) {
            errors.manager.id = 'Manager is required';
        }

        return errors as FormErrors<AnyObject>;
    };

    createUser = (user: User) => {
        if (user.role?.id > 0) {
            user.role = this.props.userRoles.find((ur) => ur.id === parseInt(user.role.id + '', 10));
        }
        if (user.office?.id > 0) {
            user.office = this.props.offices.find((o) => o.id === parseInt(user.office.id + '', 10));
        }
        if (user.manager?.id > 0) {
            user.manager = this.props.allUsers.find((u) => u.id === parseInt(user.manager.id + '', 10));
        }

        if (this.userId && this.userId > 0) {
            this.props.editUser(user);
        } else {
            user.type = { id: UserTypes.Employee, name: '' };
            this.props.createUser(user);
        }
    };

    public render() {
        const roleItems = this.props.userRoles ? this.props.userRoles.map((role: UserRole) => new SelectItem(role.id, role.role)) : undefined;
        const officeItems = this.props.offices ? this.props.offices.map((office: Office) => new SelectItem(office.id, office.name)) : undefined;
        const userItems =
            this.props.allUsers && this.props.allUsers
                ? this.props.allUsers.map((user: User) => new SelectItem(user.id, `${user.firstName} ${user.lastName}`))
                : undefined;

        return (
            <CardSection title={this.cardTitle}>
                {this.props.duplicateUser && (
                    <div style={{ color: 'red', height: '3rem' }}>{this.props.errorMessage}</div>
                )}
                <Form onSubmit={this.createUser} validate={this.validate} initialValues={this.props.selectedUser}>
                    <FormTextbox label="Email" name="username" />
                    <FormTextbox label="First Name" name="firstName" />
                    <FormTextbox label="Last Name" name="lastName" />
                    <FormTextBox label="Default Pay Rate" name="defaultPayRate" type={FormTextBoxDataType.Float} />
                    <FormSelect label="Role" name="role.id" items={roleItems} />
                    <FormSelect label="Office" name="office.id" items={officeItems} />
                    <FormSelect label="Manager" name="manager.id" items={userItems} />
                    <Button text={this.buttonText} type="submit" intent="primary" />
                </Form>
            </CardSection>
        );
    }
}

function mapStateToProps(state: IRootState) {
    return {
        userRoles: state.user.roles,
        offices: selectors.office.offices(state),
        users: selectors.user.users(state),
        allUsers: state.user.allUsers,
        selectedUser: state.user.selectedUser,
        duplicateUser: state.user.duplicateUser,
        errorMessage: state.user.errorMessage
    };
}

const mapDispatchToProps: IAdminCreateUserPageDispatchProps = {
    navigate: (path: string) => replace(path),
    createUser: (user: User) => actions.user.createUser(user),
    editUser: (user: User) => actions.user.editUser(user),
    getRoles: () => actions.user.getRoles(),
    getFieldOffices: () => actions.office.getOffices(),
    getUsers: (resetPage: boolean) => actions.user.getUsers(resetPage),
    getUserById: (id: number) => actions.user.getUserById(id),
    initUsers: () => actions.user.initUsers(),
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminCreateUserPage);



// WEBPACK FOOTER //
// ./src/components/admin/sections/AdminCreateUserPage.tsx